import { render, staticRenderFns } from "./openDoorDialog.vue?vue&type=template&id=5450fbd2&scoped=true&"
import script from "./openDoorDialog.vue?vue&type=script&lang=js&"
export * from "./openDoorDialog.vue?vue&type=script&lang=js&"
import style0 from "./openDoorDialog.vue?vue&type=style&index=0&id=5450fbd2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5450fbd2",
  null
  
)

export default component.exports